module.exports = __webpack_public_path__ + "media/Instruction_A42.1be60530.mp3";